interface PlayModalProps {
  open: boolean;
  title: string;
  episodeLabel?: string;
  onClose: () => void;
}

export default function PlayModal({ open, title, episodeLabel, onClose }: PlayModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-background-50/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-lg bg-background-100 border border-background-300/60 p-6 md:p-8 animate-fade-up">
        <span className="w-14 h-14 rounded-full bg-accent-500/15 text-accent-400 flex items-center justify-center mx-auto">
          <i className="ri-play-circle-line text-3xl" />
        </span>
        <h3 className="mt-4 text-center font-heading font-bold text-lg text-foreground-950">播放功能演示</h3>
        <p className="mt-2 text-center text-sm text-foreground-600 leading-relaxed">
          这是一个演示站点，暂不提供真实视频播放。<br />
          即将播放：<span className="text-accent-500 font-medium">{title}</span>
          {episodeLabel ? <span className="text-foreground-800"> · {episodeLabel}</span> : null}
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-md font-medium whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            我知道了
          </button>
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-2.5 rounded-md font-medium whitespace-nowrap bg-background-200/70 text-foreground-950 hover:bg-background-200 transition-colors cursor-pointer"
          >
            关闭
          </button>
        </div>
      </div>
    </div>
  );
}